import { useState } from "react";
import { Button } from "@/components/ui/button";
import { toast } from "sonner";
import { FileSpreadsheet, Loader2 } from "lucide-react";
import { exportXlsx, fmtTotal, totalsOf } from "@/lib/reportTools";

// <tfoot> totals row; `lead` = number of leading cells to skip before the columns in `cols`
export const TotalsRow = ({ rows, cols, lead = 0, label = "Total", className = "", align = "text-right" }) => {
  if (!rows.length) return null;
  const tot = totalsOf(rows, cols);
  return (
    <tfoot>
      <tr className={`border-t-2 border-slate-300 bg-slate-50 font-semibold text-navy ${className}`} data-testid="report-totals-row">
        {lead > 0 && <td colSpan={lead}>{label}</td>}
        {cols.map((c, i) => <td key={i} className={c.total ? `${align} tabular-nums` : ""}>{lead === 0 && i === 0 && !c.total ? label : fmtTotal(tot[i], c)}</td>)}
      </tr>
    </tfoot>
  );
};

export const ExportButton = ({ title, cols, rows, testId = "report-export-btn" }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try { await exportXlsx(title, cols, rows); } catch { toast.error("Export failed"); } finally { setBusy(false); }
  };
  return (
    <Button type="button" size="sm" variant="outline" onClick={go} disabled={busy || !rows.length} data-testid={testId}>
      {busy ? <Loader2 className="w-4 h-4 mr-1 animate-spin" /> : <FileSpreadsheet className="w-4 h-4 mr-1" />}Export to Excel
    </Button>
  );
};
